import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import thetaTauSeal from '../../images/IconsLogos/logoredsmall.png';
import './Navigation.scss';

// Gallery and Contact routes/pages stay live and directly linkable — just
// hidden from primary nav for now per chapter request.
const navigationItems = [
  { label: 'Home', to: '/', exact: true },
  { label: 'About', to: '/about' },
  { label: 'Members', to: '/members' },
  { label: 'Alumni', to: '/alumni' },
  { label: 'Recruitment', to: '/rush' },
];

function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleRef = useRef(null);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const closeMenu = () => setIsMenuOpen(false);

  const closeMenuAndReturnFocus = () => {
    setIsMenuOpen(false);
    toggleRef.current?.focus();
  };

  return (
    <header className="site-navigation" onKeyDown={(event) => {
      if (event.key === 'Escape' && isMenuOpen) closeMenuAndReturnFocus();
    }}>
      <div className="navigation-inner">
        <Link className="navigation-brand" to="/" onClick={closeMenu}>
          <img
            alt=""
            aria-hidden="true"
            className="navigation-brand__mark"
            src={thetaTauSeal}
          />
          Theta Tau | SLO
        </Link>
        <button
          className="navigation-toggle"
          type="button"
          aria-controls="primary-navigation"
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Close site navigation' : 'Open site navigation'}
          onClick={() => setIsMenuOpen((isOpen) => !isOpen)}
          ref={toggleRef}
        >
          <span className="navigation-toggle__bar" aria-hidden="true" />
          <span className="navigation-toggle__bar" aria-hidden="true" />
        </button>
        {/* Inside the flex row so the desktop masthead is one baseline: brand
            left, links right. On mobile it wraps to its own full-width line. */}
        <div id="primary-navigation" className={`navigation-menu${isMenuOpen ? ' is-open' : ''}`}>
          <div className="navigation-scrim" onClick={closeMenu} aria-hidden="true" />
          <nav className="navigation-menu__list" aria-label="Primary navigation">
            {navigationItems.map((item) => (
              <NavLink
                activeClassName="is-active"
                className="navigation-link"
                exact={item.exact}
                key={item.to}
                onClick={closeMenu}
                to={item.to}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Navigation;
